<div class="headerdetail">
  <div class="simbolo">
    <fa-icon
      [icon]="['chevron-left']"
      size="lg"
      class="blue-dark"
      (click)="onClose($event)"
    ></fa-icon>
  </div>
  <div class="titulo blue-dark">
    {{ nametype }}
  </div>
</div>
<div class="detailproduct">
  <div class="names blue-dark">{{ name }}</div>
  <div class="ordertype">{{ 'k000999' | translate }}</div>
  <div class="ordertypevalue">{{ ordertype }}</div>
  <div class="date">{{ 'k002802' | translate }}</div>
  <div class="datevalue">{{ datetrade }}</div>
  <div class="amountexecute">{{ 'k000306' | translate }}</div>
  <div class="amountexecutevalue">{{ amountexecute }}</div>
  <div class="valuation">{{ 'k000296' | translate }}</div>
  <div class="valuationvalue">{{ titlesexecuted }}</div>
  <div class="price">{{ 'k000048' | translate }}</div>
  <div class="pricevalue">{{ price }}</div>
  <div class="nroshare">{{ 'k000159' | translate }}</div>
  <div class="nrosharevalue">{{ isin }}</div>
</div>
